
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as indexntHZRoutjEdwoOuXl2NeEt19BZZHjHlycFaOTCubjHsMeta } from "/vercel/path0/pages/setup/index.vue?macro=true";
import { default as collaborators1L_2v17q1NWxDJ3jkSPiOGDUGKOspX3D_45QnO6E6KBioMeta } from "/vercel/path0/pages/setup/collaborators.vue?macro=true";
import { default as setupmlJSOy_45smkHquzyidOQNMwLcHPWyl1H5bzYsUUGQU_454Meta } from "/vercel/path0/pages/setup.vue?macro=true";
import { default as ui_45kit8JLv3gmENMFu82vj9W_45bTZxvE9WyFmPz_TIMhywVRY8Meta } from "/vercel/path0/pages/ui-kit.vue?macro=true";
import { default as welcomeKzeXs0p_eM_45zf48NWG2WREJVkFVHHBpdRn4wjKOgR7IMeta } from "/vercel/path0/pages/welcome.vue?macro=true";
import { default as registerYVQw2hrVHVB4lGWKPyo5FmqMHpKgdBVJqzomEM8zf3IMeta } from "/vercel/path0/pages/register.vue?macro=true";
import { default as accessfU1N6g8_Bqbk8ixqXLWC_45oll734xP2oN4X8aXgDDQ5IMeta } from "/vercel/path0/pages/app/access.vue?macro=true";
import { default as ui_45kit382QJJPYNzoRvKX0AOgUzaHpL8WTsENqNWeVTuub6MAMeta } from "/vercel/path0/pages/app/ui-kit.vue?macro=true";
import { default as moret_oI8OPIjkPV9yhQzuB6HasGTPiXuTS4n3tlZZ_LqGkMeta } from "/vercel/path0/pages/app/[event]/more.vue?macro=true";
import { default as aboutIAOZjDGXRKefL4uXKOH26NUsu8pJTFZWxFCF6SZw2y0Meta } from "/vercel/path0/pages/app/[event]/about.vue?macro=true";
import { default as indexxdW92LWs7ZfSAalXyWS_JDgdKbpKf_VuFKIaB9_45CQoIMeta } from "/vercel/path0/pages/app/[event]/index.vue?macro=true";
import { default as agenda7KfeyBlbV2FV2snizR_450LZLEMtgFBtN5MYTGF2KiQYEMeta } from "/vercel/path0/pages/app/[event]/agenda.vue?macro=true";
import { default as feedbackve9BLokOdPm4kNfvnvl9paUZluE_xhpzqCVyCi9RQdgMeta } from "/vercel/path0/pages/app/[event]/feedback.vue?macro=true";
import { default as helpdeskicmsNDp4SZPxIyMaU1_450Jz2_0qEsLUxNCru_oRm6KAgMeta } from "/vercel/path0/pages/app/[event]/helpdesk.vue?macro=true";
import { default as _91_id_93XH94Dr8eQ4G3JgI6M_45MBRBOcnSgDTKzulPUfPsGBJWUMeta } from "/vercel/path0/pages/app/[event]/news/[_id].vue?macro=true";
import { default as index26V2QvpJKuMwNswVXo8mxD0hMM8tkAtyW_45AFhZ3jfAQMeta } from "/vercel/path0/pages/app/[event]/news/index.vue?macro=true";
import { default as _91_id_93qTFkhOb_Zz_459FY49kHoMqw5aITFXlj8J4PUYp0EQIJ0Meta } from "/vercel/path0/pages/app/[event]/speakers/[_id].vue?macro=true";
import { default as indexUR7XWaCrMtG_45X_6KgO_52UldLGyYYVvr48kHSOeWYicMeta } from "/vercel/path0/pages/app/[event]/speakers/index.vue?macro=true";
import { default as _91_id_93kuX3tn8nN8mggJzQ0P7t__T3l2AWRityZokCEYPFdIkMeta } from "/vercel/path0/pages/app/[event]/sponsors/[_id].vue?macro=true";
import { default as indexQy4ewMnnTv9c8otN0FXkKnuRKOOSu_bX1setQHOPXgAMeta } from "/vercel/path0/pages/app/[event]/sponsors/index.vue?macro=true";
import { default as _91_id_93N3GJHaVuJu57euu9rvkUz5nWswemPUM2iNPPFTMPSvYMeta } from "/vercel/path0/pages/app/[event]/attendees/[_id].vue?macro=true";
import { default as index_45MEKkd5BOX5p3oVG4DvXHSBHQs5rBu4E2S0GdezflEUMeta } from "/vercel/path0/pages/app/[event]/attendees/index.vue?macro=true";
import { default as _91event_93As74aAKqFPyP_ydt39727A018eeb83bOSi5eBk_45GVU8Meta } from "/vercel/path0/pages/app/[event].vue?macro=true";
import { default as index09vNpZduKR3GLK6jSojVJNHG4FUgtLSMLrGZryUYfGYMeta } from "/vercel/path0/pages/events/[_id]/index.vue?macro=true";
import { default as guests3OQR8b4f5ktcB3RU3h646H2hAEhZ9hkw_UkpjZS4IhAMeta } from "/vercel/path0/pages/events/[_id]/guests.vue?macro=true";
import { default as mailingAvJMPqywF9_45qPsTmDY9Naiw8tDxU41g_459ks9u1VX1ccMeta } from "/vercel/path0/pages/events/[_id]/mailing.vue?macro=true";
import { default as generalIR8lMLrRqTSH0uBT7OuzR6HhITfWpbLatZrYFFGmWJkMeta } from "/vercel/path0/pages/events/[_id]/settings/general.vue?macro=true";
import { default as check_45inlPrJb2h74KUmwGL7mj7mQJhX2sY4AAiGchtKmjJHJosMeta } from "/vercel/path0/pages/events/[_id]/settings/check-in.vue?macro=true";
import { default as paymentsNqe2ggLJ0Iajb10fItVEjv7nTNDjNHhSUhRuSvUcOe4Meta } from "/vercel/path0/pages/events/[_id]/settings/payments.vue?macro=true";
import { default as collaboratorshdRkUM_ZGTNKwUL0cBkbzQuHiOKanReIWfjGxETzO2kMeta } from "/vercel/path0/pages/events/[_id]/settings/collaborators.vue?macro=true";
import { default as settings4U5CKNZEl8JOfGqIvF8NZDZ4DXam5tkcHG65m8NkvgYMeta } from "/vercel/path0/pages/events/[_id]/settings.vue?macro=true";
import { default as analyticscVLQO_45nFe9gcTYSc7Wz_dfyVZIsQVx_45tZWyrR9ko7w8Meta } from "/vercel/path0/pages/events/[_id]/analytics.vue?macro=true";
import { default as newsyc1SzELs6URpH814UatvLDi469zf_45mR29uY_45lO9XAWkMeta } from "/vercel/path0/pages/events/[_id]/guest-app/news.vue?macro=true";
import { default as pageNmh2gE73Y_MFxDJbU_45tbp3wQUmu7_wVbs8yAVAxALZ0Meta } from "/vercel/path0/pages/events/[_id]/templates/page.vue?macro=true";
import { default as otherijpd7DtANCDT6wkcik56208HsKPlh3Asx0MvaWj2cDAMeta } from "/vercel/path0/pages/events/[_id]/guest-app/other.vue?macro=true";
import { default as emailIXhpLbMqHVgWvYuRHYvBKaGxgzjyadC9DnBp2Mjp2yEMeta } from "/vercel/path0/pages/events/[_id]/templates/email.vue?macro=true";
import { default as indexyqZi3OFYM8COXSYGKk_45UDq30i_Hwh3SfvN_OpzkuF8UMeta } from "/vercel/path0/pages/events/[_id]/templates/index.vue?macro=true";
import { default as agendasi84Ogg7sI_45H4NOEW3VS6tZzCAOzFHMe_45w1x7tBIzHsMeta } from "/vercel/path0/pages/events/[_id]/guest-app/agenda.vue?macro=true";
import { default as ratingE74tMBhCSHUxNlpReVIRiScqqkP4xmgSlSmKFQlQaKIMeta } from "/vercel/path0/pages/events/[_id]/guest-app/rating.vue?macro=true";
import { default as feedbacktyTM_45ttEiL9dpcjkmKWTZHV11yGxiU5G8KmlLGQYdVMMeta } from "/vercel/path0/pages/events/[_id]/guest-app/feedback.vue?macro=true";
import { default as helpdeskJY356eFnxj0sRj0dROF5LVumKEDfjPYI10gYmX5DL9cMeta } from "/vercel/path0/pages/events/[_id]/guest-app/helpdesk.vue?macro=true";
import { default as speakersdUKlScOvMe_45ogT2Gs4wDe5rC__45uJnOtT5B_45EupfGVtAMeta } from "/vercel/path0/pages/events/[_id]/guest-app/speakers.vue?macro=true";
import { default as sponsorsxNQBY7X5ZQCcYPKNK5B2px2K_45GpE2HqPDd9g_45hdPS8YMeta } from "/vercel/path0/pages/events/[_id]/guest-app/sponsors.vue?macro=true";
import { default as indexYh17Gp1NO8zjCYRy0RzttFSRdFCgzo_45Ai_S008ssf8sMeta } from "/vercel/path0/pages/events/[_id]/builder/[_template]/index.vue?macro=true";
import { default as _91_id_93a_EFidLpCTeVUS4CG840dXuEMdgXVHjBWYwFU_MSQhsMeta } from "/vercel/path0/pages/events/[_id].vue?macro=true";
import { default as index5m4luOcQHke3VZrEYSUnzYkzST3dh3H3ZkRLIEILJ48Meta } from "/vercel/path0/pages/events/index.vue?macro=true";
import { default as new_45passwordegKr25f7r20V9YucU1s0rCKYjpY5DZQAcjFqx4u6PSkMeta } from "/vercel/path0/pages/new-password.vue?macro=true";
import { default as _91event_934ZEMv9UXFxA9IrX8wOTGup9lm3lsXjveMKUF6AzrmpEMeta } from "/vercel/path0/pages/event/[event].vue?macro=true";
import { default as _91quote_93VghfoPWGf9OrPoXbrjgZPqfh4_45U8bQMWEuQfbQS9jjIMeta } from "/vercel/path0/pages/quote/[quote].vue?macro=true";
import { default as forgotten_45password5hPVXXVPA1gsbxFL9MX_45RkPixn05OrW2f2tN3ocU0v8Meta } from "/vercel/path0/pages/forgotten-password.vue?macro=true";
import { default as _91template_93g0xCaaURAEOevLYIRNL6Int50XkrxELajm4zIajPuFgMeta } from "/vercel/path0/pages/template/[template].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta || {},
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: setupmlJSOy_45smkHquzyidOQNMwLcHPWyl1H5bzYsUUGQU_454Meta?.name,
    path: "/setup",
    meta: setupmlJSOy_45smkHquzyidOQNMwLcHPWyl1H5bzYsUUGQU_454Meta || {},
    component: () => import("/vercel/path0/pages/setup.vue"),
    children: [
  {
    name: "setup",
    path: "",
    meta: indexntHZRoutjEdwoOuXl2NeEt19BZZHjHlycFaOTCubjHsMeta || {},
    component: () => import("/vercel/path0/pages/setup/index.vue")
  },
  {
    name: "setup-collaborators",
    path: "collaborators",
    meta: collaborators1L_2v17q1NWxDJ3jkSPiOGDUGKOspX3D_45QnO6E6KBioMeta || {},
    component: () => import("/vercel/path0/pages/setup/collaborators.vue")
  }
]
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    meta: ui_45kit8JLv3gmENMFu82vj9W_45bTZxvE9WyFmPz_TIMhywVRY8Meta || {},
    component: () => import("/vercel/path0/pages/ui-kit.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: welcomeKzeXs0p_eM_45zf48NWG2WREJVkFVHHBpdRn4wjKOgR7IMeta || {},
    component: () => import("/vercel/path0/pages/welcome.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerYVQw2hrVHVB4lGWKPyo5FmqMHpKgdBVJqzomEM8zf3IMeta || {},
    component: () => import("/vercel/path0/pages/register.vue")
  },
  {
    name: "app-access",
    path: "/app/access",
    meta: accessfU1N6g8_Bqbk8ixqXLWC_45oll734xP2oN4X8aXgDDQ5IMeta || {},
    component: () => import("/vercel/path0/pages/app/access.vue")
  },
  {
    name: "app-ui-kit",
    path: "/app/ui-kit",
    meta: ui_45kit382QJJPYNzoRvKX0AOgUzaHpL8WTsENqNWeVTuub6MAMeta || {},
    component: () => import("/vercel/path0/pages/app/ui-kit.vue")
  },
  {
    name: _91event_93As74aAKqFPyP_ydt39727A018eeb83bOSi5eBk_45GVU8Meta?.name,
    path: "/app/:event()",
    meta: _91event_93As74aAKqFPyP_ydt39727A018eeb83bOSi5eBk_45GVU8Meta || {},
    component: () => import("/vercel/path0/pages/app/[event].vue"),
    children: [
  {
    name: "app-event-more",
    path: "more",
    meta: moret_oI8OPIjkPV9yhQzuB6HasGTPiXuTS4n3tlZZ_LqGkMeta || {},
    component: () => import("/vercel/path0/pages/app/[event]/more.vue")
  },
  {
    name: "app-event-about",
    path: "about",
    meta: aboutIAOZjDGXRKefL4uXKOH26NUsu8pJTFZWxFCF6SZw2y0Meta || {},
    component: () => import("/vercel/path0/pages/app/[event]/about.vue")
  },
  {
    name: "app-event",
    path: "",
    meta: indexxdW92LWs7ZfSAalXyWS_JDgdKbpKf_VuFKIaB9_45CQoIMeta || {},
    component: () => import("/vercel/path0/pages/app/[event]/index.vue")
  },
  {
    name: "app-event-agenda",
    path: "agenda",
    meta: agenda7KfeyBlbV2FV2snizR_450LZLEMtgFBtN5MYTGF2KiQYEMeta || {},
    component: () => import("/vercel/path0/pages/app/[event]/agenda.vue")
  },
  {
    name: "app-event-feedback",
    path: "feedback",
    meta: feedbackve9BLokOdPm4kNfvnvl9paUZluE_xhpzqCVyCi9RQdgMeta || {},
    component: () => import("/vercel/path0/pages/app/[event]/feedback.vue")
  },
  {
    name: "app-event-helpdesk",
    path: "helpdesk",
    meta: helpdeskicmsNDp4SZPxIyMaU1_450Jz2_0qEsLUxNCru_oRm6KAgMeta || {},
    component: () => import("/vercel/path0/pages/app/[event]/helpdesk.vue")
  },
  {
    name: "app-event-news-_id",
    path: "news/:_id()",
    component: () => import("/vercel/path0/pages/app/[event]/news/[_id].vue")
  },
  {
    name: "app-event-news",
    path: "news",
    meta: index26V2QvpJKuMwNswVXo8mxD0hMM8tkAtyW_45AFhZ3jfAQMeta || {},
    component: () => import("/vercel/path0/pages/app/[event]/news/index.vue")
  },
  {
    name: "app-event-speakers-_id",
    path: "speakers/:_id()",
    component: () => import("/vercel/path0/pages/app/[event]/speakers/[_id].vue")
  },
  {
    name: "app-event-speakers",
    path: "speakers",
    meta: indexUR7XWaCrMtG_45X_6KgO_52UldLGyYYVvr48kHSOeWYicMeta || {},
    component: () => import("/vercel/path0/pages/app/[event]/speakers/index.vue")
  },
  {
    name: "app-event-sponsors-_id",
    path: "sponsors/:_id()",
    component: () => import("/vercel/path0/pages/app/[event]/sponsors/[_id].vue")
  },
  {
    name: "app-event-sponsors",
    path: "sponsors",
    meta: indexQy4ewMnnTv9c8otN0FXkKnuRKOOSu_bX1setQHOPXgAMeta || {},
    component: () => import("/vercel/path0/pages/app/[event]/sponsors/index.vue")
  },
  {
    name: "app-event-attendees-_id",
    path: "attendees/:_id()",
    component: () => import("/vercel/path0/pages/app/[event]/attendees/[_id].vue")
  },
  {
    name: "app-event-attendees",
    path: "attendees",
    meta: index_45MEKkd5BOX5p3oVG4DvXHSBHQs5rBu4E2S0GdezflEUMeta || {},
    component: () => import("/vercel/path0/pages/app/[event]/attendees/index.vue")
  }
]
  },
  {
    name: _91_id_93a_EFidLpCTeVUS4CG840dXuEMdgXVHjBWYwFU_MSQhsMeta?.name,
    path: "/events/:_id()",
    meta: _91_id_93a_EFidLpCTeVUS4CG840dXuEMdgXVHjBWYwFU_MSQhsMeta || {},
    component: () => import("/vercel/path0/pages/events/[_id].vue"),
    children: [
  {
    name: "events-_id",
    path: "",
    component: () => import("/vercel/path0/pages/events/[_id]/index.vue")
  },
  {
    name: "events-_id-guests",
    path: "guests",
    meta: guests3OQR8b4f5ktcB3RU3h646H2hAEhZ9hkw_UkpjZS4IhAMeta || {},
    component: () => import("/vercel/path0/pages/events/[_id]/guests.vue")
  },
  {
    name: "events-_id-mailing",
    path: "mailing",
    meta: mailingAvJMPqywF9_45qPsTmDY9Naiw8tDxU41g_459ks9u1VX1ccMeta || {},
    component: () => import("/vercel/path0/pages/events/[_id]/mailing.vue")
  },
  {
    name: "events-_id-settings",
    path: "settings",
    meta: settings4U5CKNZEl8JOfGqIvF8NZDZ4DXam5tkcHG65m8NkvgYMeta || {},
    component: () => import("/vercel/path0/pages/events/[_id]/settings.vue"),
    children: [
  {
    name: "events-_id-settings-general",
    path: "general",
    meta: generalIR8lMLrRqTSH0uBT7OuzR6HhITfWpbLatZrYFFGmWJkMeta || {},
    component: () => import("/vercel/path0/pages/events/[_id]/settings/general.vue")
  },
  {
    name: "events-_id-settings-check-in",
    path: "check-in",
    meta: check_45inlPrJb2h74KUmwGL7mj7mQJhX2sY4AAiGchtKmjJHJosMeta || {},
    component: () => import("/vercel/path0/pages/events/[_id]/settings/check-in.vue")
  },
  {
    name: "events-_id-settings-payments",
    path: "payments",
    meta: paymentsNqe2ggLJ0Iajb10fItVEjv7nTNDjNHhSUhRuSvUcOe4Meta || {},
    component: () => import("/vercel/path0/pages/events/[_id]/settings/payments.vue")
  },
  {
    name: "events-_id-settings-collaborators",
    path: "collaborators",
    meta: collaboratorshdRkUM_ZGTNKwUL0cBkbzQuHiOKanReIWfjGxETzO2kMeta || {},
    component: () => import("/vercel/path0/pages/events/[_id]/settings/collaborators.vue")
  }
]
  },
  {
    name: "events-_id-analytics",
    path: "analytics",
    meta: analyticscVLQO_45nFe9gcTYSc7Wz_dfyVZIsQVx_45tZWyrR9ko7w8Meta || {},
    component: () => import("/vercel/path0/pages/events/[_id]/analytics.vue")
  },
  {
    name: "events-_id-guest-app-news",
    path: "guest-app/news",
    meta: newsyc1SzELs6URpH814UatvLDi469zf_45mR29uY_45lO9XAWkMeta || {},
    component: () => import("/vercel/path0/pages/events/[_id]/guest-app/news.vue")
  },
  {
    name: "events-_id-templates-page",
    path: "templates/page",
    meta: pageNmh2gE73Y_MFxDJbU_45tbp3wQUmu7_wVbs8yAVAxALZ0Meta || {},
    component: () => import("/vercel/path0/pages/events/[_id]/templates/page.vue")
  },
  {
    name: "events-_id-guest-app-other",
    path: "guest-app/other",
    meta: otherijpd7DtANCDT6wkcik56208HsKPlh3Asx0MvaWj2cDAMeta || {},
    component: () => import("/vercel/path0/pages/events/[_id]/guest-app/other.vue")
  },
  {
    name: "events-_id-templates-email",
    path: "templates/email",
    meta: emailIXhpLbMqHVgWvYuRHYvBKaGxgzjyadC9DnBp2Mjp2yEMeta || {},
    component: () => import("/vercel/path0/pages/events/[_id]/templates/email.vue")
  },
  {
    name: "events-_id-templates",
    path: "templates",
    component: () => import("/vercel/path0/pages/events/[_id]/templates/index.vue")
  },
  {
    name: "events-_id-guest-app-agenda",
    path: "guest-app/agenda",
    meta: agendasi84Ogg7sI_45H4NOEW3VS6tZzCAOzFHMe_45w1x7tBIzHsMeta || {},
    component: () => import("/vercel/path0/pages/events/[_id]/guest-app/agenda.vue")
  },
  {
    name: "events-_id-guest-app-rating",
    path: "guest-app/rating",
    meta: ratingE74tMBhCSHUxNlpReVIRiScqqkP4xmgSlSmKFQlQaKIMeta || {},
    component: () => import("/vercel/path0/pages/events/[_id]/guest-app/rating.vue")
  },
  {
    name: "events-_id-guest-app-feedback",
    path: "guest-app/feedback",
    meta: feedbacktyTM_45ttEiL9dpcjkmKWTZHV11yGxiU5G8KmlLGQYdVMMeta || {},
    component: () => import("/vercel/path0/pages/events/[_id]/guest-app/feedback.vue")
  },
  {
    name: "events-_id-guest-app-helpdesk",
    path: "guest-app/helpdesk",
    meta: helpdeskJY356eFnxj0sRj0dROF5LVumKEDfjPYI10gYmX5DL9cMeta || {},
    component: () => import("/vercel/path0/pages/events/[_id]/guest-app/helpdesk.vue")
  },
  {
    name: "events-_id-guest-app-speakers",
    path: "guest-app/speakers",
    meta: speakersdUKlScOvMe_45ogT2Gs4wDe5rC__45uJnOtT5B_45EupfGVtAMeta || {},
    component: () => import("/vercel/path0/pages/events/[_id]/guest-app/speakers.vue")
  },
  {
    name: "events-_id-guest-app-sponsors",
    path: "guest-app/sponsors",
    meta: sponsorsxNQBY7X5ZQCcYPKNK5B2px2K_45GpE2HqPDd9g_45hdPS8YMeta || {},
    component: () => import("/vercel/path0/pages/events/[_id]/guest-app/sponsors.vue")
  },
  {
    name: "events-_id-builder-_template",
    path: "builder/:_template()",
    meta: indexYh17Gp1NO8zjCYRy0RzttFSRdFCgzo_45Ai_S008ssf8sMeta || {},
    component: () => import("/vercel/path0/pages/events/[_id]/builder/[_template]/index.vue")
  }
]
  },
  {
    name: "events",
    path: "/events",
    meta: index5m4luOcQHke3VZrEYSUnzYkzST3dh3H3ZkRLIEILJ48Meta || {},
    component: () => import("/vercel/path0/pages/events/index.vue")
  },
  {
    name: "new-password",
    path: "/new-password",
    meta: new_45passwordegKr25f7r20V9YucU1s0rCKYjpY5DZQAcjFqx4u6PSkMeta || {},
    component: () => import("/vercel/path0/pages/new-password.vue")
  },
  {
    name: "event-event",
    path: "/event/:event()",
    meta: _91event_934ZEMv9UXFxA9IrX8wOTGup9lm3lsXjveMKUF6AzrmpEMeta || {},
    component: () => import("/vercel/path0/pages/event/[event].vue")
  },
  {
    name: "quote-quote",
    path: "/quote/:quote()",
    meta: _91quote_93VghfoPWGf9OrPoXbrjgZPqfh4_45U8bQMWEuQfbQS9jjIMeta || {},
    component: () => import("/vercel/path0/pages/quote/[quote].vue")
  },
  {
    name: "forgotten-password",
    path: "/forgotten-password",
    meta: forgotten_45password5hPVXXVPA1gsbxFL9MX_45RkPixn05OrW2f2tN3ocU0v8Meta || {},
    component: () => import("/vercel/path0/pages/forgotten-password.vue")
  },
  {
    name: "template-template",
    path: "/template/:template()",
    meta: _91template_93g0xCaaURAEOevLYIRNL6Int50XkrxELajm4zIajPuFgMeta || {},
    component: () => import("/vercel/path0/pages/template/[template].vue")
  }
]